<form *ngIf="editable" [formGroup]="form" (ngSubmit)="onSubmit()">
  <fieldset class="users-to-be-notified-section">
    <div>Select who should be notified by email:</div>
    <cc-search-and-select
      name="user-selection"
      customClass="multiple-line"
      [items]="users"
      [multiple]="true"
      [clearable]="false"
      [searchable]="true"
      [closeOnSelect]="false"
      [selected]="form.value.selectedUsers"
      (change)="onUserChange($event)"
      (open)="onOpen()"
    >
      <ng-template #customOptionTemplate let-option>
        <div class="sm-flex sm-items-center">
          <cc-user-avatar [user]="option" class="sm-mr-1 small-avatar"></cc-user-avatar>
          <span class="sm-overflow-hidden sm-text-ellipsis">{{ option.fullName || option.email }}</span>
          <span *ngIf="option.email === currentUser.email" class="current-user-label">(You)</span>
        </div>
      </ng-template>
    </cc-search-and-select>
  </fieldset>
  <fieldset>
    <h2>Set when to send notifications:</h2>
    <ol formGroupName="expiryTimes">
      <li
        class="sm-flex sm-gap-2 sm-items-center"
        *ngFor="
          let periodDefinition of form.controls['expiryTimes'].value | keyvalue: keepDefaultOrder;
          let index = index
        "
      >
        <input
          type="checkbox"
          [formControlName]="periodDefinition.key"
          [value]="true"
          [id]="uniqueIdentifier + periodDefinition.key"
          data-test="period-checkbox"
        />
        <label class="sm-cursor-pointer" [for]="uniqueIdentifier + periodDefinition.key">
          {{ notificationDescriptions[periodDefinition.key] }}
        </label>
      </li>
    </ol>
  </fieldset>
  <fieldset class="expiry-update-controls-container">
    <button class="expiry-update-control save" type="submit" [disabled]="!form.dirty">Save</button>
    <button class="expiry-update-control reset" type="button" (click)="resetForm()">Reset</button>
  </fieldset>
</form>

<div *ngIf="!editable" class="read-only-notification-list">
  <div class="sm-mb-2" i18n>
    People who will be notified when a list item expires in column:
  </div>
  <div *ngFor="let user of form?.value?.selectedUsers" class="option">
    {{ user.fullName || user.email }}
  </div>
</div>
